import styled, { css } from 'styled-components'
import React from 'react'
import { FreeCouponListSpace } from 'src/types/api'
import { FreeCouponPageProps } from 'src/pages/FreeCouponPage'
import { Roboto_num1_b24 } from 'src/styles/fonts/RobotoFonts'
import { Noto_body1_m16, Noto_body2_m14 } from 'src/styles/fonts/NotoSansKrFonts'
import { Chips } from 'src/components/common/Chips'
import { VerticalDottedDivider } from 'src/components/common/Divider'
import CouponCircleImage from 'src/components/common/CouponCircleImage'
import { ellip } from 'src/styles/mixin'

const FreeCouponCard = ({
  CouponName,
  RegularPrice,
  CouponImage,
  Idx,
  Status,
  freeCouponDetailNav,
}: Partial<FreeCouponListSpace.FreeCouponItemsType> &
  Pick<FreeCouponPageProps, 'freeCouponDetailNav'>) => {
  const convertUseFlagAndStatusToText: {
    [key: number]: { statusText: string; statusColor: string }
  } = {
    0: {
      statusText: '사용 가능',
      statusColor: 'var(--black-50)',
    },
    1: {
      statusText: '사용 가능',
      statusColor: 'var(--black-50)',
    },
    2: {
      statusText: '사용 완료',
      statusColor: 'var(--black-50)',
    },
    3: {
      statusText: '첫 번째 쿠폰 사용 다음날 지급',
      statusColor: 'var(--brand-50)',
    },
  }

  return (
    <S.CardContainer $status={Status!} onClick={() => freeCouponDetailNav(Idx!, Status!)}>
      <S.CardTextContainer>
        <S.RegularPrice $status={Status!}>{RegularPrice?.toLocaleString()}</S.RegularPrice>
        <S.CouponName $status={Status!}>{CouponName}</S.CouponName>
        <Chips.Item size="small" color={convertUseFlagAndStatusToText[Status!].statusColor}>
          {convertUseFlagAndStatusToText[Status!]?.statusText}
        </Chips.Item>
      </S.CardTextContainer>
      <S.CardImgContainer $status={Status!}>
        <VerticalDottedDivider />
        <CouponCircleImage
          src={CouponImage!}
          style={css`
            cursor: pointer;
          `}
        />
      </S.CardImgContainer>
    </S.CardContainer>
  )
}

export default FreeCouponCard

const S = {
  CardContainer: styled.section<{ $status?: number }>`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-radius: 20px;
    gap: 16px;
    padding: 30px 20px;
    cursor: pointer;
    ${(props) =>
      (props.$status === 0 || props.$status === 1) &&
      //사용가능
      css`
        outline: 1px solid var(--brand-50);
        background: var(--white);
        box-shadow: 0 2px 6px 0 rgba(0, 131, 252, 0.4);
      `}
    ${(props) =>
      props.$status === 2 &&
      css`
        outline: 1px solid var(--black-10);
        background: var(--black-2);
      `}
    ${(props) =>
      props.$status === 3 &&
      //1일 후 사용 가능
      css`
        border: 1px solid var(--black-10);
        background: var(--white);
      `}
  `,
  CouponName: styled.span<{ $status?: number }>`
    margin-bottom: 8px;
    ${Noto_body1_m16};
    color: ${(props) =>
      props.$status === 0 || props.$status === 1 ? 'var(--black-90)' : 'var(--black-30)'};
    ${ellip('line1')};
  `,

  RegularPrice: styled.span<{ $status?: number }>`
    ${Roboto_num1_b24};
    color: ${(props) =>
      props.$status === 0 || props.$status === 1 ? 'var(--brand-50)' : 'var(--black-30)'};
    &:after {
      content: '원';
      ${Noto_body2_m14};
      color: var(--black-50);
    }
  `,
  CardTextContainer: styled.div`
    width: 63%;
    display: flex;
    flex-direction: column;
  `,
  CardImgContainer: styled.div<{ $status?: number }>`
    > img {
      opacity: ${(props) => (props.$status === 0 || props.$status === 1 ? 1 : 0.3)};
    }
    display: flex;
    gap: 16px;
    align-items: center;
  `,
}
